export default __webpack_public_path__ + "static/media/logo_kplus_4_g.bf1bdbff.svg";